import {
  ICertificateElementContainer,
  ISortableCertificateElement
} from "~/interfaces/contentManagementInterfaces";
import TrackedModel from "~/models/tracked/trackedModel";
import { parseCertificateElementHTML } from "~/utils/certificateUtils";
import { Constructor } from "../../../../global/constructor";
import { CertificateDynamicInputType } from "../../enums/certificateDynamicInputType";
import Certificate from "../certificate";

export default function TextElement<TBase extends Constructor,
  TCertificateElement extends ISortableCertificateElement &
    TrackedModel,
  TContainer extends TrackedModel &
    ICertificateElementContainer<TCertificateElement> &
    TCertificateElement>(Base: TBase) {
  return class extends Base {
    editor: object;
    viewer: object;
    html: string;
    certificate: Certificate;
    except= ['editor', 'viewer', 'createEmbeddedObject', 'organization_id', 'htmlNode'];

    liveDataHTML(repeatable_index = null, scopedLiveData = null){
      return parseCertificateElementHTML({html: this.$html, getValue: (dynamicInputId)  => this.liveDataForInput(dynamicInputId, repeatable_index, scopedLiveData)})
    }

    liveDataForInput(dynamicInputId, repeatable_index = null, scopedLiveData = null) {
      if (scopedLiveData) {
        if (!scopedLiveData[dynamicInputId]){
          return this.certificate.validUpstreamValues(scopedLiveData)[dynamicInputId]
        }else{
          return scopedLiveData[dynamicInputId]
        }
      } else {
        return this.certificate.getMappedDataValue(dynamicInputId, repeatable_index)
      }
    }
    get $html(){
      return $(`<span>${this.html}</span>`)
    }
    replaceOrDeleteStaleInputReferences() {

      const $html =this.$html.clone()
      const textInputs = this.getTextInputs(this.certificate.certificateDynamicInputs, []);

      $html.find("var").each(function (index, el) {
        const $el = $(el);
        const dynamicInputId = $el.data().dynamic.id;

        const correspondingInput = textInputs.find(input => input.client_id === dynamicInputId);

        if (!!correspondingInput) {
          const textNotMatching = correspondingInput.name !== $el.text();
          const isRepeatable = correspondingInput.type === CertificateDynamicInputType.Repeatable;
          if (textNotMatching && !isRepeatable) {
            $el.text(correspondingInput.name);
          } else if (textNotMatching && isRepeatable) {
            if (!$el.text().startsWith(correspondingInput.name)) {
              const repeatableNumber = $el.text().split(".")[1];
              const newName = correspondingInput.name + "." + repeatableNumber;
              $el.text(newName);
            }
          }
        } else {
          $el.remove();
        }
      }.bind(this));
      this.html = $html.html();
    }

    getTextInputs(dynamicInputs, textInputs) {
      dynamicInputs.forEach(input => {
        if (input.type === CertificateDynamicInputType.Text) {
          textInputs.push(input);
        }
    
        if (input.type === CertificateDynamicInputType.Object) {
          this.getTextInputs(input.certificateDynamicInputs, textInputs);
        }

        if (input.type === CertificateDynamicInputType.Repeatable) {
          textInputs.push(input);
        }
      });

      return textInputs;
    }
  }
}